import http from 'axios';
import { API_URL } from '../runtimeConfig';

const CustomerService = () => {
    const getCustomer = async () => {
        const url = API_URL + '/shop/customer';

        try {
            const res = await http.get(url, {
                headers: {
                    'Content-Type': 'application/json',
            }}
                );
            return res.data;
        } catch (err) {
            console.log(err);
        }
    }

    return { getCustomer }
}

export default CustomerService;
